import { attr } from '@ember-data/model';
import ALMOST_MAX_VALUE from '@square/dashboard-utilities/utils/math/almost-max-value';
import Discount from '@square/dashboard-items-data/models/discount';
export default Discount.extend({
  enabledUnitsAll: attr('boolean', {
    defaultValue: true
  }),
  ordinal: attr('number', {
    defaultValue: ALMOST_MAX_VALUE
  }),
  applicationMethod: attr('enum', {
    enumClass: Discount.ApplicationMethod,
    defaultValue: Discount.ApplicationMethod.COMP
  }),
  discountType: attr('enum', {
    enumClass: Discount.DiscountType,
    defaultValue: Discount.DiscountType.FIXED
  }),
  percentage: attr('number', {
    defaultValue: 100
  })
}).reopenClass({
  _modelNameForMigration: 'comp-discount',
  cogsType: 'DISCOUNT',
  catalogType() {
    return 'COMP_DISCOUNT';
  },
  currentUserAffectsEnabledUnitsAll: false
});